import { FC } from 'react';
import { Checkbox } from 'antd';
import BaseItem, { BaseItemProps } from './BaseItem';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

interface CheckboxItemProps extends BaseItemProps {
  onChange?: (e: CheckboxChangeEvent) => void;
}

const CheckboxItem: FC<CheckboxItemProps> = ({ onChange, ...rest }) => {
  return (
    <BaseItem
      valuePropName='checked'
      normalize={(value) => Number(value)}
      {...rest}
    >
      <Checkbox onChange={onChange} />
    </BaseItem>
  );
};

export default CheckboxItem;
